import { render, staticRenderFns } from "./phonenumber-renderer.vue?vue&type=template&id=67df126c&"
import script from "./phonenumber-renderer.vue?vue&type=script&lang=js&"
export * from "./phonenumber-renderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports